// prcng-568_v1 - ad landing flow: on call + masterclass bundle
import React from 'react'
import { Trans, withI18nContext } from '@mc/i18n'
import { i18nInstance } from '../../../i18n/i18nInstance'
import {
  TermsLink,
  AITermsLink,
  PrivacyLink,
  SpeechPolicyLink,
} from '../../links'

const BundleLegalComp = ({ className = '' }: { className?: string }) => (
  <p className={`${className} mc-mb-4 mc-text-small`}>
    <Trans
      i18nKey='emailCapture.bundle'
      ns='@mc/legal'
      components={{
        terms: <TermsLink />,
        'ai-terms': <AITermsLink />,
        privacy: <PrivacyLink />,
        'speech-policy': <SpeechPolicyLink />,
      }}
    />
  </p>
)

export const BundleLegal = withI18nContext(i18nInstance)(BundleLegalComp)
